import { useQuery } from "@tanstack/react-query";
import { useDataSource } from "@/data/DataProvider";
import { useIdentity } from "@/auth/ClientAuthProvider";

/** Products, carriers and the illustration behind the plan. */
export function usePlan() {
  const source = useDataSource();
  const id = useIdentity();
  return useQuery({
    queryKey: ["plan", id.orgId, id.leadId],
    queryFn: () => source.getPlan(id),
    staleTime: 5 * 60_000,
  });
}

/** The submitted pre-application, masked by the server. */
export function useApplicationSummary() {
  const source = useDataSource();
  const id = useIdentity();
  return useQuery({
    queryKey: ["application-summary", id.orgId, id.leadId],
    queryFn: () => source.getApplicationSummary(id),
    staleTime: 5 * 60_000,
  });
}
